<template>
  <page-wrap>
    <vehicle-manage-panel source="jws" :use-jws-api="true" readonly show-person-code extended-filters />
  </page-wrap>
</template>

<script>
import PageWrap from '../components/PageWrap'
import VehicleManagePanel from '../components/VehicleManagePanel'

export default {
  name: 'CheliangJwsView',
  components: { PageWrap, VehicleManagePanel }
}
</script>
